import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import DrilldownTableSS from '../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import { getCSCEselector } from '../../../../../../../redux/reducers/reducerSlices/CSCEReducer';
import { capitalizeFirstLetter, formatDate_MM_DD_YYYY, getMessageType,showFileNameMessage } from '../../../../../../Assests/Utility';
import TinyLoader from '../../../../../Common/TinyLoader/TinyLoader';
import DatePickerSS from '../../../../../DatePickerSS/DatePickerSS';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import CustomDropDown from "../../../../../Common/CustomDropDown/CustomDropDown";
import '../Metric/CSCEMetric.css'
import CustomButtonSS from '../../../../../Common/CustomButton/CustomButtonSS';
import { getLivChatLogDetailsList } from '../../../../../../../redux/reducers/reducerSlices/GetLiveChatLogDetails';
import moment from 'moment';
import ChatDetails from '../ChatDetails/ChatDetails';
import CommonChart from '../../../Dashboard/DefaultDashboard/Graphs/CommonChart';
import { createChartsProps, donutType } from '../../../../../../Assests/DashboardUtility';
import { csceLogsData } from '../../../../../../Assests/GraphUtilities';
import NoDataSS from '../../../Dashboard/DefaultDashboard/DrillDownReports/Common/NodataSS';

const CSCELogs = ({ themeSelected = 'light-mode', view }) => {
    const dispatch = useDispatch();
    const divRef = useRef(null);
    const lastKeyRef = useRef(null); // ← keep track without re-rendering

    const { isLoading, logs } = useSelector(getCSCEselector);
    const [logsData, setLogsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [lastEvaluatedKeyForLiveChat, setLastEvaluatedKeyForLiveChat] = useState(null);
    const [chatInfiniteScroll, setChatInfiniteScroll] = useState(false);
    const [hasMoreLiveChat, setHasMoreLiveChat] = useState(true);
    const [chatScroll, setChatScroll] = useState(false);

    const [csceLogsDataState, setCsceLogsDataState] = useState({...csceLogsData })

    const titleDD = [
        { id: "intent", name: "Intent" },
        { id: 'customerFirstName', name: 'First name' },
        { id: 'customerLastName', name: 'Last name' },
        { id: "customerEmail", name: "Email" },
        { id: "supportType", name: "Support Type" },
        { id: "sessionId", name: "Session Id" },
        { id: "createdOn", name: "Created on" }
    ];

    const formatListDataDrillDown = (data) => {
        return data.map((el, index) => ({
            0: el.intent ? el.intent : '',
            1: el.customerFirstName ? capitalizeFirstLetter(el.customerFirstName) : '-',
            2: el.customerLastName ? capitalizeFirstLetter(el.customerLastName) : '-',
            3: el.customerEmail ? el.customerEmail : '-',
            4: el.supportType ? el.supportType : '-',
            5: el.sessionId ? el.sessionId : '-',
            6:  el.createdOn ? el.createdOn : '-',
        }));
    };

    const getBodyData = () => formatListDataDrillDown(logsData);

    const fetchData = () => {
        // if (isLoading || loading || lastKeyRef.current === null && metricsData.length > 0) return;
        if (isLoading || loading) return
        // setLoading(true);

        const params = {
            limit: 15,
            lastEvaluatedKey: lastKeyRef.current,
            crudType: 'S',
            
        };

        const operationObj = {
            type: 'Fetch Logs',
            status: '',
        };

        dispatch({ type: sagaActions.GET_CSCE_LOGS, payload: params, operationObj });
    };

    useEffect(() => {
        dispatch({ type: sagaActions.CLEAR_CSCE_LOGS });
        dispatch({ type: sagaActions.INITIATE_CSCE_METRICS_LOADER, payload: true });

        setLogsData([]);
        lastKeyRef.current = null;

        setTimeout(() => {
            fetchData()    
        }, 100);

        return () => {
            dispatch({ type: sagaActions.CLEAR_CSCE_LOGS });
        };
    }, []);

    useEffect(() => {
        if (logs?.Items?.length) {
            setLogsData(prev => [...prev, ...logs.Items]);
            formGraphData()
        } else {
            setLogsData([])
        }

        // Only reset `lastKeyRef` and `loading`, not the data
        lastKeyRef.current = logs?.LastEvaluatedKey || null;
        setLoading(false);
    }, [logs]);

    const formGraphData = () => {
        if (logs) {
            const intents = ["EmployeeDetails", "SearchSPROOrder", "TerminateEmployee", "PayrollErrorDetection", "Dimensions"];

 
        const counts = intents.map(intent => logs?.intentCount[intent] || 0);
 
            const csceLogsChart = createChartsProps(counts, donutType.csceLogsSummary, themeSelected, csceLogsData)
                   let setData = { ...csceLogsChart };
                   setData.themeSelected = themeSelected
                   setCsceLogsDataState(setData)
        }

   }


    // const handleScroll = _.debounce((e) => {
    //     const target = e.target;
    //     const nearBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 1;

    //     if (nearBottom && !isLoading && !loading && lastKeyRef.current !== null) {
    //         fetchData();
    //     }
    // }, 200);

    // useEffect(() => {
    //     const container = divRef.current;
    //     if (container) {
    //         container.addEventListener('scroll', handleScroll);
    //     }
    //     return () => {
    //         container?.removeEventListener('scroll', handleScroll);
    //         handleScroll.cancel();
    //     };
    // }, [handleScroll]);




    return (

        <div className="pt-2">

            {view === 'T' ? <div className="csceLogsContainer mt-1" ref={divRef}>
                    {/* <div className='' > */}
                        <DrilldownTableSS
                            key={Math.random()}
                            themeSelected={themeSelected}
                            bodyData={getBodyData()}
                            titleData={titleDD}
                            showCollapse={false}
                            showInput={false}
                            showSort={false}
                            hasCollapsableContent={false}
                            collapsableData={[]}
                            accordionPrimaryIndex={1}
                            drillDownReport={logs?.Items}
                            initiateDrillDownReport={isLoading}
                            loaderArray={7}
                            sortingAction={sagaActions.SORT_SS_USER_TABLE}
                            subRoot={{ pathName: '' }}
                            showUTCTime={true}
                        />
                    {/* </div> */}

                {/* {(isLoading || loading) && (
                    <div className='d-flex justify-content-center w-100'>
                        <TinyLoader />
                    </div>
                )} */}
            </div> : 
                <>
                <div className='col-12 text-center'>
                                    <span className='graphHeading'>Customer intent metrics</span><br />
                                </div>
            <div className='d-flex flex-row pt-4 mt-1'>
            <div className={`flex-grow-1 d-flex align-items-center justify-content-center responsive-chart detention-legend ${false ? 'mt-5' : ''}`}>{
                true ? <CommonChart data={csceLogsDataState} /> : <NoDataSS themeSelected={themeSelected} />}</div>
        </div>
                </>
            }
        </div>
    );
};

export default CSCELogs;